var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileSidebarOnlinestore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3375 10.9314L19.9789 3.68142C20.0974 3.15795 19.7011 2.65948 19.1663 2.65948H5.52806L5.20979 1.09759C5.13049 0.708289 4.78924 0.428711 4.39337 0.428711H0.833333C0.37309 0.428711 0 0.803236 0 1.26525V1.82294C0 2.28495 0.37309 2.65948 0.833333 2.65948H3.25983L5.69899 14.6302C5.11545 14.9671 4.72222 15.5987 4.72222 16.3229C4.72222 17.401 5.59278 18.2749 6.66667 18.2749C7.74056 18.2749 8.61111 17.401 8.61111 16.3229C8.61111 15.7766 8.38726 15.283 8.02694 14.9287H15.3064C14.9461 15.283 14.7222 15.7766 14.7222 16.3229C14.7222 17.401 15.5928 18.2749 16.6667 18.2749C17.7406 18.2749 18.6111 17.401 18.6111 16.3229C18.6111 15.5501 18.1636 14.8823 17.5146 14.566L17.7062 13.7199C17.8247 13.1964 17.4283 12.6979 16.8936 12.6979H7.57351L7.34625 11.5826H17.5249C17.914 11.5826 18.2513 11.3123 18.3375 10.9314Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSidebarOnlinestore);
export default __webpack_public_path__ + "static/media/profile-sidebar-onlinestore.87188e89.svg";
export { ForwardRef as ReactComponent };